import clsx from "clsx";
import React, { FC } from "react";

import { FreeDrawText } from "@/sx-layout/components/plotmap/components/freeDraw/models";

type Props = {
  id: string;
  text: FreeDrawText;
  mapRatio: number;
  selected?: boolean;
  onClick?: () => void;
  style: React.CSSProperties;
};

export const TextObject: FC<Props> = ({ text, mapRatio, selected, ...props }) => {
  return (
    <div {...props} className="text-item cursor-pointer" style={props.style}>
      <div
        id={`text-moveable-${text.freetext_id}`}
        className={clsx(
          "flex justify-center items-center inline-block bg-white border border-black whitespace-pre-wrap",
          selected ? " shadow-[0_0_5px_0_rgba(0,0,0,0.7)]" : ""
        )}
      >
        <span
          className="font-bold"
          style={{
            fontSize: text.font_size * mapRatio,
            color: text.color,
          }}
        >
          {text.content}
        </span>
      </div>
    </div>
  );
};
